/* onetimeblind app (Netflix paradigm, homepage option D).
   openBrowse(key): picker → browse screen for a category (featured hero from featMap, chip context, shelves filtered)
   closeBrowse():   back to the picker
   Chips filter the shelves by occasion. The URL hash (#easter) keeps the browser Back button and shared links working. */
(() => {
  function init(root) {
    if (root.dataset.otbReady) return;
    root.dataset.otbReady = '1';

    const picker = root.querySelector('[data-screen="picker"]');
    const browse = root.querySelector('[data-screen="browse"]');
    const title = browse.querySelector('[data-title]');
    const feats = [...browse.querySelectorAll('[data-feat]')];
    const chips = [...browse.querySelectorAll('[data-chip]')];
    const cards = [...browse.querySelectorAll('.otb-card[data-cats]')];
    const shelves = [...browse.querySelectorAll('[data-shelf]')];
    const occCards = [...browse.querySelectorAll('.otb-occ[data-open]')];
    const empty = browse.querySelector('[data-empty]');

    const names = {};
    const kinds = {};
    root.querySelectorAll('.otb-tile[data-open]').forEach((t) => {
      names[t.dataset.open] = t.querySelector('.otb-tile__name').textContent.trim();
      kinds[t.dataset.open] = t.dataset.kind;
    });
    const occasionKeys = chips.map((c) => c.dataset.chip).filter((k) => k !== 'all');
    const allKey = Object.keys(kinds).find((k) => kinds[k] === 'all');

    // Category squares and By Occasion cards: a random photo from the products in each category, new on every page load.
    // Eligible photos come from the cards' data-img (scripts borrow their matching mini-movie's still).
    const pool = {};
    cards.forEach((c) => {
      if (!c.dataset.img) return;
      c.dataset.cats.split(/\s+/).forEach((k) => { if (k) (pool[k] = pool[k] || new Set()).add(c.dataset.img); });
    });
    root.querySelectorAll('.otb-tile[data-open], .otb-occ[data-open]').forEach((t) => {
      const photos = pool[t.dataset.open] ? [...pool[t.dataset.open]] : [];
      if (!photos.length) return; // keeps the abstract color art
      const art = t.querySelector('.otb-art');
      const img = new Image();
      img.className = 'otb-art__photo';
      img.alt = '';
      img.decoding = 'async';
      img.onload = () => art.classList.add('has-photo');
      img.src = photos[Math.floor(Math.random() * photos.length)];
      art.appendChild(img);
    });

    // Home has a transparent header over the photo (white mark); browse has the white header (blue mark)
    function setView(view) {
      root.dataset.view = view;
    }

    let base = null; // category the shelves are limited to (null = everything)
    let occ = 'all'; // active occasion chip

    function setFeat(key) {
      const target = feats.some((f) => f.dataset.feat === key) ? key : allKey;
      feats.forEach((f) => { f.hidden = f.dataset.feat !== target; });
      updateBar();
    }

    // Back + title bar: transparent over the featured photo, solid once the photo has scrolled under it
    const bar = browse.querySelector('.otb-browsebar');
    function updateBar() {
      if (!bar || browse.hidden) return;
      const feat = feats.find((f) => !f.hidden);
      const solid = !feat || feat.getBoundingClientRect().bottom <= bar.getBoundingClientRect().bottom + 1;
      bar.classList.toggle('is-solid', solid);
    }
    window.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar);

    function apply() {
      cards.forEach((c) => {
        const cs = ` ${c.dataset.cats.split(/\s+/).join(' ')} `;
        const inBase = !base || cs.includes(` ${base} `);
        const inOcc = occ === 'all' || cs.includes(` ${occ} `);
        c.hidden = !(inBase && inOcc);
      });
      let total = 0;
      shelves.forEach((s) => {
        const track = s.querySelector('.otb-track');
        if (track) track.scrollLeft = 0;
        if (s.dataset.shelf === 'occasions') return;
        const n = s.querySelectorAll('.otb-card:not([hidden])').length;
        s.hidden = n === 0;
        const count = s.querySelector('[data-count]');
        if (count) count.textContent = n ? `(${n})` : '';
        total += n;
      });
      const occShelf = shelves.find((s) => s.dataset.shelf === 'occasions');
      if (occShelf) {
        let visible = 0;
        occCards.forEach((b) => { b.hidden = b.dataset.open === occ; if (!b.hidden) visible += 1; });
        occShelf.hidden = visible === 0;
      }
      empty.hidden = total > 0;
      chips.forEach((c) => {
        const on = c.dataset.chip === occ;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function openBrowse(key, push = true) {
      const isOcc = occasionKeys.includes(key);
      base = isOcc || kinds[key] === 'all' ? null : key;
      occ = isOcc ? key : 'all';
      title.textContent = names[key] || key;
      setFeat(key);
      apply();
      picker.hidden = true;
      browse.hidden = false;
      setView('browse');
      window.scrollTo(0, 0);
      updateBar();
      if (push) history.pushState({ otb: key }, '', `#${key}`);
    }

    function closeBrowse(push = true) {
      browse.hidden = true;
      picker.hidden = false;
      setView('picker');
      window.scrollTo(0, 0);
      if (push && location.hash) history.pushState({}, '', location.pathname + location.search);
    }

    function fchip(el) {
      occ = el.dataset.chip;
      if (base === null) {
        // Browsing an occasion or "everything": the chip changes the context (title + featured hero)
        const key = occ === 'all' ? allKey : occ;
        if (key) {
          title.textContent = names[key] || key;
          setFeat(key);
          history.replaceState({ otb: key }, '', `#${key}`);
        }
      }
      apply();
    }

    root.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-open]');
      if (opener) { e.preventDefault(); openBrowse(opener.dataset.open); return; }
      if (e.target.closest('[data-close]')) {
        if (history.state && history.state.otb) history.back(); else closeBrowse();
        return;
      }
      const chip = e.target.closest('[data-chip]');
      if (chip) { fchip(chip); return; }
      if (e.target.closest('[data-otb-home]') && !browse.hidden) { e.preventDefault(); closeBrowse(); }
    });

    window.addEventListener('popstate', () => {
      const k = decodeURIComponent(location.hash.slice(1));
      if (k && names[k]) openBrowse(k, false); else closeBrowse(false);
    });
    const k0 = decodeURIComponent(location.hash.slice(1));
    if (k0 && names[k0]) openBrowse(k0, false);

    // Hero carousel: background photo + matching caption crossfade (CSS opacity); auto-advance, dots, swipe;
    // pauses while the caption is hovered or anything on the stage has focus; off for reduced motion
    const carousel = root.querySelector('.otb-stage');
    const slides = [...root.querySelectorAll('.otb-slide')];
    const captions = [...root.querySelectorAll('.otb-caption')];
    const dots = [...root.querySelectorAll('.otb-dot')];
    if (carousel && slides.length > 1) {
      const ms = Number(root.dataset.interval) || 5000;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let i = 0;
      let timer = null;
      const show = (n) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, j) => s.classList.toggle('is-active', j === i));
        captions.forEach((c, j) => {
          const on = j === i;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-hidden', on ? 'false' : 'true');
          c.inert = !on;
        });
        dots.forEach((d, j) => { d.classList.toggle('is-active', j === i); d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      };
      const stop = () => { clearInterval(timer); timer = null; };
      const start = () => { if (reduce) return; stop(); timer = setInterval(() => show(i + 1), ms); };
      dots.forEach((d, j) => d.addEventListener('click', () => { show(j); start(); }));
      const captionBox = root.querySelector('.otb-captions');
      if (captionBox) { captionBox.addEventListener('mouseenter', stop); captionBox.addEventListener('mouseleave', start); }
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      let x0 = null;
      carousel.addEventListener('touchstart', (e) => { if (e.target.closest('.otb-grid')) return; x0 = e.touches[0].clientX; stop(); }, { passive: true });
      carousel.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
        x0 = null;
        start();
      });
      show(0);
      start();
    }
    setView(browse.hidden ? 'picker' : 'browse');
  }

  const boot = () => document.querySelectorAll('[data-otb-app]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot); // theme editor
})();
